import { render, staticRenderFns } from "./SolutionsPayments.vue?vue&type=template&id=d2fd9608&scoped=true"
import script from "./SolutionsPayments.js?vue&type=script&lang=js&external"
export * from "./SolutionsPayments.js?vue&type=script&lang=js&external"
import style0 from "./SolutionsPayments.scss?vue&type=style&index=0&id=d2fd9608&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fd9608",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTag: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Tag/Tag.vue').default,HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default})
